var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 5C6.38747 5 6.61133 5.22386 6.61133 5.5V8.5C6.61133 8.77614 6.38747 9 6.11133 9C5.83519 9 5.61133 8.77614 5.61133 8.5V5.5C5.61133 5.22386 5.83519 5 6.11133 5ZM6.11134 4.24907C6.52502 4.24907 6.86037 3.91371 6.86037 3.50003C6.86037 3.08635 6.52502 2.751 6.11134 2.751C5.69766 2.751 5.3623 3.08635 5.3623 3.50003C5.3623 3.91371 5.69766 4.24907 6.11134 4.24907ZM0.111328 6C0.111328 2.68629 2.79762 0 6.11133 0C9.42504 0 12.1113 2.68629 12.1113 6C12.1113 9.31371 9.42504 12 6.11133 12C2.79762 12 0.111328 9.31371 0.111328 6ZM6.11133 1C3.3499 1 1.11133 3.23858 1.11133 6C1.11133 8.76142 3.3499 11 6.11133 11C8.87275 11 11.1113 8.76142 11.1113 6C11.1113 3.23858 8.87275 1 6.11133 1Z",
    fill: "#17827B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b2af5b9bafe85f571e566fe23a021f04.svg";
export { ForwardRef as ReactComponent };